<template>
  <div class="wrap">

    <div class="bannerimg">
      <img src="@/assets/image/work-banner.jpg" alt="" style="width: 100%" />
    </div>
    <div class="pagew content">
      <div class="flexbox">
        <div class="left">
          <div class="cont">
            营业执照
          </div>
        </div>
        <div class="right">
          <div class="imgbox">
            <div class="each">
              <div>
                <img
                  src="@/assets/image/lisence.jpg"
                  alt=""
                  style="width: 800px; "
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Footer class="workspace-footer" :show="true" />
  </div>
</template>

<script>
// import Footer from "@/components/Footer/index";
// import Header from "@/components/Header/Header";
export default {
  name: "workspace",
  // components: { Footer,Header },
};
</script>

<style scoped lang="scss">
.wrap {
  width: 100%;

  .bannerimg {
    z-index: -2;
  }

  .content {
    text-align: center;
    .flexbox {
      width: 100%;
      display: flex;
      .left {
        width: 20%;
        height: 650px;
        display: flex;
        align-items: center;
        background-color: #25877d;
        .cont {
          text-align: center;
          width: 85%;
          margin: 0 auto;
          color: #ffffff;
          line-height: 30px;
          font-size: 14px;
          font-weight: bold;
        }
      }
      .right {
        width: 80%;
        // height: 50vh;
        display: flex;
        margin-left: 50px;
        .imgbox {
          width: 33%;
          // height: 50vh;
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          justify-content: center;
          .each {
            width: 80%;
            .title {
              width: 80%;
              margin: 0 auto;
              text-align: left;
              font-size: 16px;
              color: #25877d;
              font-weight: bold;
              .info {
                font-weight: 700;
                padding: 10px 0;
              }
              .name {
                font-size: 12px;
                color: #000000;
              }
            }
          }
        }
      }
    }
  }


}
</style>
<style lang="scss">
.workspace-footer.footerbox {
  margin-top: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/view/Match/lisence.vue